import directives from '../module';
import {ProjectPageCtrl} from './ProjectPage';
import SpinnerSvc from 'services/SpinnerSvc';
import {AnimatronPreviews} from '../../services/AnimatronPreviewsSvc';
import {PlayerSvc} from '../../services/PlayerSvc';
import {Utils} from 'underscore-extensions';

class ProjectPageCanvasCtrl implements ng.IComponentController {
    private static readonly players: Player[] = [];
    private readonly ProjectPageCtrl: ProjectPageCtrl;
    private readonly canvas = <HTMLElement>this.$element[0].firstChild;

    project: anm.Project;
    projectWidth: number;
    playerSelector: HTMLElement;
    projectModalSelector: HTMLElement;

    thumbnail: string;

    old: boolean;

    constructor(private $scope: any,
                private $element: ng.IAugmentedJQuery,
                private $stateParams: any,
                private Player: PlayerSvc,
                private OldPlayer: PlayerSvc,
                private AnimatronPreviews: AnimatronPreviews) {
    }

    $onInit() {
        this.ProjectPageCtrl.projectPromise.then((p: anm.Project) => {
            this.project              = p;
            this.playerSelector       = this.$element[0].parentElement;
            this.projectModalSelector = document.querySelector('.wrapper-proj');
            if (this.ProjectPageCtrl.twoPlayers) {
                this.playerSelector.style.minWidth = 'initial';
            }

            this.$scope.fullscreen = options.handHeld;
            if (this.project && this.project.id === this.$stateParams.projectId) {
                this.createPlayer();
            }

            Utils.scopedEvent('keyup', this.$scope, (e: KeyboardEvent) => {
                if (e.keyCode === 27 && document.querySelector('#project-player').classList.contains('fullscreen')) {
                    this.ProjectPageCtrl.toggleFullscreen();
                }
            });

            this.ProjectPageCtrl.toggleFullscreen = () => {
                document.querySelector('#project-player').classList.toggle('fullscreen');
                this.projectWidth = window.innerWidth;
                this.ProjectPageCtrl.player.then(p => this.resize(p)());
                this.$scope.fullscreen = true;
            };
        });
    }

    resize = (player?: Player) => () => {
        const [width, height] = this.calculate();
        if (player) {
            player.setSize(width, height);
        }
    };

    getHeightMargin(): number {
        return this.$scope.fullscreen ? (options.handHeld ? document.querySelector('header').offsetHeight : 0) : 210;
    }

    calculate() {
        if (_.isUndefined(this.projectWidth)) {
            this.projectWidth = Math.max(this.project.width, 640);
        }
        let width                  = this.$scope.fullscreen ? window.innerWidth : this.projectWidth,
            height                 = Math.round(this.project.height * width / this.project.width);
        const bodyDimension        = document.body.getBoundingClientRect(),
            windowWidth            = bodyDimension.width / (this.ProjectPageCtrl.twoPlayers ? 2 : 1),
            windowHeight           = bodyDimension.height,
            heightMargin           = this.getHeightMargin(),
            widthMargin            = this.$scope.fullscreen || options.handHeld ? 0 : 160,
            windowHeightScaled     = windowHeight - heightMargin,
            windowWidthScaled      = windowWidth - widthMargin,
            displayedProjectHeight = Math.round(height * windowWidthScaled / width),
            displayedProjectWidth  = Math.round(width * windowHeightScaled / height);

        if (width > windowWidthScaled) {
            width  = windowWidthScaled;
            height = displayedProjectHeight;
        }
        if (height > windowHeightScaled) {
            width  = displayedProjectWidth;
            height = windowHeightScaled;
        }

        this.projectModalSelector.style.width = (this.old ? 2 : 1) * Math.max(width + 20, 390) + 'px';
        this.playerSelector.style.width       = width + 'px';
        this.playerSelector.style.height      = height + 'px';
        this.projectModalSelector.classList[(windowWidth - width < 250 ) ? 'add' : 'remove']('left-movie-buttons');
        return [width, height];
    }

    createPlayer() {
        const suffix   = this.ProjectPageCtrl.twoPlayers ? Math.random() : '';
        this.canvas.id = 'project-canvas-' + this.project.id + suffix;
        this.thumbnail = this.AnimatronPreviews.pickPreview(this.project.preview_metadata);

        const img   = this.canvas.querySelector('.preview-image');
        img.onerror = () => img.style.display = 'none';

        const [width, height] = this.calculate();

        const svc: PlayerSvc = this.old ? this.OldPlayer : this.Player;

        if (window.isPhantom || this.$stateParams.stopPlay === 'true') return;
        this.ProjectPageCtrl.player = svc.createPlayer(this.project, this.canvas.id, {
            autoPlay: !options.handHeld && !this.ProjectPageCtrl.twoPlayers,
            width, height, thumbnail: this.thumbnail
        }, player => {
            this.canvas.removeChild(img);
            SpinnerSvc.hide();
            if (this.ProjectPageCtrl.twoPlayers) {
                ProjectPageCanvasCtrl.players.push(player);
                if (ProjectPageCanvasCtrl.players.length === 2) {
                    setTimeout(() => ProjectPageCanvasCtrl.players.forEach(p => p.play()));
                }
            }
        }).then((player: Player) => {
            Utils.scopedEvent('resize', this.$scope, _.throttle(this.resize(player), 300));

            this.$scope.$watch(() => this.ProjectPageCtrl.sizes.projectSize, (newWidth?: string) => {
                if (_.isUndefined(newWidth) || newWidth === this.projectWidth.toString()) {
                    return;
                }
                this.projectWidth = parseInt(newWidth, 10);
                this.resize(player)();
            });

            return player;
        });
    }

    $onDestroy() {
        this.Player.resetPlayer(this.ProjectPageCtrl.player);
    }
}

directives.component('projectPageCanvas', {
    bindings: {
        old: '<'
    },
    controller: ProjectPageCanvasCtrl,
    require: {ProjectPageCtrl: '^projectPage'},
    template: `<div><img class="preview-image" ng-src="{{$ctrl.thumbnail}}" alt="{{$ctrl.project.name}}"/></div>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/projectPageCanvasDirective.ts